// Tidy Printify descriptions: intro paragraph stays, "- " lines become bullets, the rest folds into "More details".
(function () {
  function tidy() {
    var box = document.querySelector('.product__description');
    if (!box || box.dataset.tacTidy) return;
    box.dataset.tacTidy = '1';
    // Some Printify descriptions are one text block split by <br>; turn those lines into paragraphs first.
    if (!box.querySelector('p') && box.querySelector('br')) {
      box.innerHTML = box.innerHTML.split(/<br\s*\/?>/i).map(function (s) { return s.trim(); })
        .filter(Boolean).map(function (s) { return '<p>' + s + '</p>'; }).join('');
    }
    var ps = Array.prototype.slice.call(box.querySelectorAll(':scope > p, :scope > .rte > p, :scope > div > p'));
    if (ps.length < 3) return;
    var host = ps[0].parentNode, rest = ps.slice(1);
    var det = document.createElement('details'), sum = document.createElement('summary');
    sum.textContent = 'More details'; det.className = 'tac-more'; det.appendChild(sum);
    var list = null;
    rest.forEach(function (p) {
      var t = p.textContent.trim();
      if (/^[-•–]\s+/.test(t)) {
        if (!list) { list = document.createElement('ul'); det.appendChild(list); }
        var li = document.createElement('li'); li.textContent = t.replace(/^[-•–]\s+/, ''); list.appendChild(li); p.remove();
      } else {
        list = null; var h = document.createElement('p'); h.className = 'tac-more__h'; h.textContent = t; det.appendChild(h); p.remove();
      }
    });
    host.appendChild(det);
  }
  if (document.readyState !== 'loading') tidy(); else document.addEventListener('DOMContentLoaded', tidy);
})();

// Quantity stepper beside Add to cart. The input keeps its form= attribute and product-info.js holds a reference, so moving it is safe.
(function () {
  function row() {
    document.querySelectorAll('product-info').forEach(function (info) {
      var qty = info.querySelector('.product-form__quantity');
      var submit = info.querySelector('.product-form__submit');
      if (!qty || !submit || submit.parentNode.classList.contains('tac-buy-row')) return;
      var wrap = document.createElement('div');
      wrap.className = 'tac-buy-row';
      submit.parentNode.insertBefore(wrap, submit);
      wrap.appendChild(qty);
      wrap.appendChild(submit);
    });
  }
  if (document.readyState !== 'loading') row(); else document.addEventListener('DOMContentLoaded', row);
})();

// Long size lists: show the first 8 sizes (plus the selected one) with a "Show all sizes" toggle.
// Re-applied after product-info.js re-renders the picker on variant change.
(function () {
  var LIMIT = 8, expanded = false;
  function apply() {
    document.querySelectorAll('variant-selects fieldset').forEach(function (fs) {
      if (!fs.querySelector('.tac-size-cell')) return;
      var inputs = fs.querySelectorAll('input[type="radio"]');
      var old = fs.querySelector('.tac-size-more');
      if (inputs.length <= LIMIT + 2) { if (old) old.remove(); return; }
      inputs.forEach(function (input, i) {
        var label = fs.querySelector('label[for="' + input.id + '"]');
        var hide = !expanded && i >= LIMIT && !input.checked;
        input.classList.toggle('tac-size-extra', hide);
        if (label) label.classList.toggle('tac-size-extra', hide);
      });
      var btn = old || document.createElement('button');
      if (!old) {
        btn.type = 'button';
        btn.className = 'tac-size-more';
        btn.addEventListener('click', function () { expanded = !expanded; apply(); });
        fs.appendChild(btn);
      }
      var text = expanded ? 'Show fewer sizes' : 'Show all ' + inputs.length + ' sizes';
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      // Rewriting textContent adds a text node, which would retrigger the observer below forever
      if (btn.textContent !== text) btn.textContent = text;
    });
  }
  function init() {
    apply();
    // Observe product-info, not variant-selects: product-info.js replaces the variant-selects element itself
    document.querySelectorAll('variant-selects').forEach(function (vs) {
      new MutationObserver(function (m) { if (m.some(function (r) { return r.addedNodes.length; })) apply(); })
        .observe(vs.closest('product-info') || vs.parentNode, { childList: true, subtree: true });
    });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();

// Dispatch day: before the cutoff on a weekday ships today, otherwise the next weekday. Uses UK time.
// window.tacDispatch(now) re-renders, so a fake date can be passed when testing.
(function () {
  var DAY = 86400000;
  function ukParts(now) {
    var p = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23' })
      .formatToParts(now).forEach(function (x) { p[x.type] = +x.value; });
    return p;
  }
  function render(now) {
    now = now || new Date();
    document.querySelectorAll('.tac-dispatch').forEach(function (el) {
      var p = ukParts(now), cutoff = +el.dataset.cutoff;
      var today = Date.UTC(p.year, p.month - 1, p.day), d = today;
      var wd = new Date(d).getUTCDay();
      if (wd === 0 || wd === 6 || p.hour >= cutoff) d += DAY;
      while ([0, 6].indexOf(new Date(d).getUTCDay()) !== -1) d += DAY;
      var label = d === today ? 'today' : d === today + DAY ? 'tomorrow'
        : new Date(d).toLocaleDateString('en-GB', { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short' }).replace(',', '');
      el.textContent = el.dataset.template.replace('[cutoff]', el.dataset.cutoffLabel).replace('[day]', label);
      el.hidden = false;
      var sep = el.parentNode.querySelector('.tac-dispatch__sep');
      if (sep) sep.hidden = false;
    });
  }
  window.tacDispatch = render;
  if (document.readyState !== 'loading') render(); else document.addEventListener('DOMContentLoaded', function () { render(); });
})();

// Free-shipping progress: refreshed from /cart.js after add to cart, cart edits and back/forward navigation.
(function () {
  function paint(count) {
    document.querySelectorAll('.tac-ship-progress').forEach(function (box) {
      var t = +box.dataset.threshold || 3, needed = t - count;
      var msg = box.querySelector('.tac-ship-progress__msg'), bar = box.querySelector('.tac-ship-progress__bar');
      msg.textContent = needed > 0
        ? box.dataset.textMore.replace('[count]', needed + ' more print' + (needed > 1 ? 's' : '')) + ' →'
        : box.dataset.textDone;
      bar.setAttribute('aria-valuenow', Math.min(count, t));
      bar.firstElementChild.style.width = Math.min(100, (count / t) * 100) + '%';
    });
  }
  function refresh() {
    if (!document.querySelector('.tac-ship-progress')) return;
    fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { paint(cart.item_count); })
      .catch(function () {});
  }
  window.tacShipProgress = paint;
  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
